import { render, staticRenderFns } from "./ZohoChannels.vue?vue&type=template&id=5029bb42&scoped=true"
import script from "./ZohoChannels.vue?vue&type=script&lang=js"
export * from "./ZohoChannels.vue?vue&type=script&lang=js"
import style0 from "./ZohoChannels.vue?vue&type=style&index=0&id=5029bb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029bb42",
  null
  
)

export default component.exports